export default "__VITE_ASSET__Cubyo1bC__"